import { useTranslation } from 'react-i18next';
import { GenericObj } from '@solvhealth/types/interfaces/generics';
import { getFieldValueFromFormDataFieldName, getStandardFormFieldData } from '../../../util';
import { SectionContentItem } from '../../../interfaces';
import { useSolvSelector } from '~/reducers';

const useGetContentForSection = (namespace: 'paperwork' | 'providerGroupPaperwork') => {
  const paperwork = useSolvSelector((state) => state.paperwork);
  const { t } = useTranslation(['paperwork', 'providerGroupPaperwork']);

  const getContentForSection = (
    sectionFields: string[] | null,
    isCustomPaperworkSection = false,
    trim: string | null = null
  ) => {
    let sectionContent: SectionContentItem[] = [];

    if (isCustomPaperworkSection) {
      paperwork?.customFields?.forEach((field: GenericObj) => {
        sectionContent.push({
          [field.field_name]: {
            displayName: field.field_display_name,
            value: paperwork.formData[field.field_name],
          },
        });
      });
    } else {
      sectionFields?.forEach((field: string) => {
        const fieldData = getStandardFormFieldData(field, paperwork);
        if (fieldData) {
          let name: string = t(
            `${namespace}:standardFields.${fieldData.field_name}.finalize` as any,
            fieldData.field_display_name
          );
          if (trim) {
            if (name.startsWith(trim)) {
              name = name.substring(trim.length);
            }
          }
          sectionContent.push({
            [fieldData.field_name]: {
              displayName: name,
              value: getFieldValueFromFormDataFieldName(fieldData, paperwork.formData),
            },
          });
        }
      });
    }

    return sectionContent;
  };

  return getContentForSection;
};

export default useGetContentForSection;
